import React from "react"

import { Element, Text } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { PullQuoteType } from "types/shared-components"

interface OwnProps {
  data: Maybe<PullQuoteType>
}

export type PullQuoteProps = OwnProps

const PullQuote: React.FC<PullQuoteProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null

  const { author, quote_text } = data?.primary
  const marginBottom = author ? ["30", "40", "60"] : 0

  return (
    <Element py={["40", "60", "80"]} px={["30", "40"]}>
      <Element m="0 auto" maxWidth="contentWidth">
        <Text
          as="h2"
          fontSize={["28", "text.displayBody"]}
          lineHeight={["38px", "2.2"]}
          mb={marginBottom}
          variant="displayBody"
        >
          {quote_text}
        </Text>
        {author && (
          <Text fontSize={["12", "text.captionCaps"]} variant="captionCaps">
            {author}
          </Text>
        )}
      </Element>
    </Element>
  )
}

export default PullQuote
